import React from "react";
import { Menu, Dropdown } from "antd";

import { SearchIcon, MenuIcon, UploadFileIcon } from "../../../../assets/svg";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import { MOBILE_WIDTH } from "../../../../constants/constants";
import {
  SmallReportIcon,
  SmallSearchIcon,
} from "../../../../assets/svg/mobileIcon";

const SearchBar = (props) => {
  const {
    handleOnClear,
    search,
    showClear,
    handleOnChange,
    showPatientLookup,
    showPatientReport,
    notConfigured,
    handleDownloadReport,
  } = props;
  const currentTab = localStorage.getItem("tabSet");
  const { width } = useWindowDimensions();

  const getLabel = () => {
    switch (currentTab) {
      case "activeItem":
        return "Clear active chat";
      case "unClaimedItem":
        return "Clear unclaimed chat";
      default:
        return "Clear active chat";
    }
  };

  const menu =
    width > MOBILE_WIDTH ? (
      <Menu>
        <Menu.Item onClick={handleOnClear} key="0" className="red-text">
          {getLabel()}
        </Menu.Item>
      </Menu>
    ) : (
      <Menu>
        <Menu.Item key="0" onClick={showPatientLookup}>
          <span className="dark-text">
            {" "}
            <SmallSearchIcon />
            Patient Lookup
          </span>
        </Menu.Item>
        <Menu.Item key="1" className="dark-text" onClick={showPatientReport}>
          <span className="dark-text">
            <SmallReportIcon />
            Patient Report
          </span>
        </Menu.Item>
        {!notConfigured && (
          <Menu.Item key="2" onClick={handleDownloadReport}>
            <span className="patient-menu-item">
              {UploadFileIcon}
              Import
            </span>
          </Menu.Item>
        )}
        <Menu.Item onClick={handleOnClear} key="3" className="red-text">
          {getLabel()}
        </Menu.Item>
      </Menu>
    );

  return (
    <div className="search-bar-container">
      <div className="search-bar">
        <div className="search-icon">
          <SearchIcon />
        </div>

        <input
          className="search-input"
          id="search"
          type="text"
          name="search"
          placeholder="Search"
          value={search}
          onChange={handleOnChange}
          autoComplete="off"
        />
      </div>

      {showClear &&
        (currentTab !== "otherItem" && currentTab !== "queuedItem") && (
          <div className="options-wrapper">
            <Dropdown
              overlayClassName="clear-chat-dropdown"
              placement="bottomRight"
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              overlay={menu}
              trigger={["click"]}
            >
              <div className="menu-icon">
                <MenuIcon />
              </div>
            </Dropdown>
          </div>
        )}
    </div>
  );
};

export default SearchBar;
